import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";

export const TABLE_COLUMNS = [
  {
    Header: "Deco Name",
    accessor: "name",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Colors Max",
    accessor: "colorsMax",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Product Example",
    accessor: "productExamples",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
